export const IMAGE_CONFIG_LIST = 'IMAGE_CONFIG_LIST';
export const IMAGE_CONFIG_LIST_SUCCESS = 'IMAGE_CONFIG_LIST_SUCCESS';
export const IMAGE_CONFIG_LIST_ERROR = 'IMAGE_CONFIG_LIST_ERROR';

export const IMAGE_CONFIG_LIST_DETAILS = 'IMAGE_CONFIG_LIST_DETAILS';
export const IMAGE_CONFIG_LIST_DETAILS_SUCCESS = 'IMAGE_CONFIG_LIST_DETAILS_SUCCESS';
export const IMAGE_CONFIG_LIST_DETAILS_ERROR = 'IMAGE_CONFIG_LIST_DETAILS_ERROR';

export const ADD_IMAGE_CONFIG_LIST_DETAILS = 'ADD_IMAGE_CONFIG_LIST_DETAILS';
export const ADD_IMAGE_CONFIG_LIST_DETAILS_SUCCESS = 'ADD_IMAGE_CONFIG_LIST_DETAILS_SUCCESS';
export const ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR = 'ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR';

export const UPDATE_IMAGE_CONFIG_LIST_DETAILS = 'UPDATE_IMAGE_CONFIG_LIST_DETAILS';
export const UPDATE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS = 'UPDATE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS';
export const UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR = 'UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR';

export const DELETE_IMAGE_CONFIG_LIST_DETAILS = 'DELETE_IMAGE_CONFIG_LIST_DETAILS';
export const DELETE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS = 'DELETE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS';
export const DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR = 'DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR';


export const DATA_GENERATIONTYPE = 'DATA_GENERATIONTYPE';
export const DATA_GENERATIONTYPE_SUCCESS = 'DATA_GENERATIONTYPE_SUCCESS';
export const DATA_GENERATIONTYPE_ERROR = 'DATA_GENERATIONTYPE_ERROR';


export const MODELTYPE_LIST = 'MODELTYPE_LIST';
export const MODELTYPE_LIST_SUCCESS = 'MODELTYPE_LIST_SUCCESS';
export const MODELTYPE_LIST_ERROR = 'MODELTYPE_LIST_ERROR';

export const MODEL_CLASSIFICATION = 'MODEL_CLASSIFICATION';
export const MODEL_CLASSIFICATION_SUCCESS = 'MODEL_CLASSIFICATION_SUCCESS';
export const MODEL_CLASSIFICATION_ERROR = 'MODEL_CLASSIFICATION_ERROR';